import { createDocModalExecutor } from '@organisms/actions/createDocModalExecutor';
import { ICustomEmailExecutorProps } from './ICustomEmailExecutorProps';
import { CustomEmailExecutorModal } from './CustomEmailExecutorModal';

export const CustomEmailExecutor = createDocModalExecutor<ICustomEmailExecutorProps>({
    modal: CustomEmailExecutorModal,
    defaultModalSize: 'l',
    emptyElement: <div />,
    mapProps: ({ objId, action, okButtonText, cancelButtonText, modalSize, completeHandler }) => ({
        docId: objId ?? '',
        actionKey: action.key ?? '',
        title: action.options?.title ?? '',
        message: action.options?.message ?? '',
        okButtonText,
        cancelButtonText,
        modalSize,
        completeHandler,
    }),
});
